import React from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";

import { ROUTES, userType } from "../../../constants";

import MainWrapper from "../MainWrapper";
import PrivateRoute from "./PrivateRoute";
import Modal from "../../Views/Login/Modal";
import Footer from "../../Layout/footer/Footer";
import Topbar from "../../Layout/topbar/Topbar";
import LoginForm from "../../Views/Login/LoginForm";
import Shutterb from "../../../views/Shutterb/Shutterb";
import { userRoutes, sbRoutes } from "../../../system/routes";
import EmailConfirmation from "../../Views/EmailConfimation/index";
import ChangePassword from "../../../container/Views/ChangePassword";
import Spinner from "../../../shared/components/ErrorBoundary/Spinner";
import Overlay from "../../../shared/components/ErrorBoundary/Overlay";
import ShutterbLogin from "../../Views/Login/ShutterbLogin/ShutterbLogin";
import EventBookingForm from "../../../views/Customer/EventBooking/EventBookingForm";
import ViewShutterBProfile from "../../../views/Customer/ShutterBProfile/ViewShutterBProfile";
import ShutterBSelectionForm from "../../../views/Customer/EventBooking/AvailableShutterbSelection/ShutterBSelectionForm";
import SharedGallery from "../../../views/Customer/CustomerDashboard/CustomerDashboardTabs/MyEventsTab/MyEventsDashboard/Tabs/SharedGallery";

const RouterWrapper = (props) => {
  // eslint-disable-next-line
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  return (
    <>
      <>
        {/* topbar will not render for these two routes */}
        {window.location.href.includes("/email_confirmation/:queryparam") ||
        window.location.href.includes("/change_password") ? null : (
          <Topbar />
        )}
        <MainWrapper>
          <main>
            <Switch>
              <Route
                exact
                path="/"
                component={() => (
                  <Modal setIsModalOpen={setIsModalOpen} isPage />
                )}
              />
              <Route
                exact
                path="/email_confirmation/:queryparam"
                component={EmailConfirmation}
              />
              <Route exact path="/change_password" component={ChangePassword} />
              <Route
                exact
                path="/be-a-shutterb"
                component={() => <Shutterb />}
              />
              <Route
                exact
                path="/Login"
                component={() => (
                  <Modal setIsModalOpen={setIsModalOpen} isPage />
                )}
              />
              <Route
                exact
                path={ROUTES.CUSTOMER_LOGIN}
                component={() => <LoginForm isPage />}
              />
              <Route
                exact
                path={ROUTES.SHUTTERB_LOGIN}
                component={() => <ShutterbLogin />}
              />

              <Route
                exact
                path="/event_booking"
                component={() => <EventBookingForm />}
              />
              <Route
                exact
                path="/event_booking/:isBookingStatus/:eventGroupId/:eventId?"
                component={() => <EventBookingForm />}
              />
              <Route
                exact
                path="/shutterb_selection/:token/:eventId/:orderItemId"
                component={() => <ShutterBSelectionForm />}
              />
              <Route
                exact
                path="/ShutterbProfile/:id"
                component={() => <ViewShutterBProfile />}
              />
              <Route
                exact
                path="/SharedGallery"
                component={() => <SharedGallery />}
              />
              {props.userType === userType.SHUTTERB ? (
                sbRoutes.map((prop, key) => (
                  <PrivateRoute
                    key={key}
                    path={prop.path}
                    component={prop.component}
                    {...props}
                  />
                ))
              ) : props.userType === userType.USER ||
                props.userType === userType.ADMIN ? (
                userRoutes.map((prop, key) => (
                  <PrivateRoute
                    key={key}
                    path={prop.path}
                    component={prop.component}
                    isAuthenticated={props.isAuthenticated}
                    {...props}
                  />
                ))
              ) : (
                <Redirect
                  to={{ pathname: "/", state: { from: props.location } }}
                />
              )}
              {props.isAuthenticated ? (
                <Redirect
                  to={{
                    pathname: "/CustomerDashboard",
                    state: { from: props.location },
                  }}
                />
              ) : props.isShutterbAuthenticated ? (
                <Redirect
                  to={{
                    pathname: "/shutterbDashboard",
                    state: { from: props.location },
                  }}
                />
              ) : (
                <Redirect
                  to={{ pathname: "/", state: { from: props.location } }}
                />
              )}
            </Switch>
          </main>
        </MainWrapper>
        {/* footer will not render for these two routes */}
        {window.location.href.includes("/email_confirmation/:queryparam") ||
        window.location.href.includes("/change_password") ? null : (
          <Footer />
        )}
      </>

      <Spinner />
      <Overlay />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isShutterbAuthenticated:
      state.shutterbAuthentication.isShutterbAuthenticated,
    isAuthenticated: state.authentication.isAuthenticated,
    userType: state.authentication.userType,
  };
};

export default connect(mapStateToProps)(React.memo(RouterWrapper));
